<div class="wk-restore-version-dialog">
  <mat-toolbar class="wk-restore-toolbar">
    <mat-toolbar-row
      class="wk-restore-toolbar-row wk-restore-toolbar-align-items"
    >
      <h1 class="restore-dialog-header">
        Revert
        <span
          class="restore-dialog-file-name"
          [matTooltip]="documentName"
          >
          {{documentName}}
        </span>
        to Version {{versionId}}
      </h1>
      <button mat-icon-button class="close-icon" (click)="closeDialog()">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <table class="wk-restore-label" aria-hidden="true">
    <th id="wk-restore"></th>
    <tr class="wk-restore-label-row1">
      <td class="wk-restore-label-coulmn1">
        <label for="revert as"> Revert as:</label>
      </td>
      <td class="wk-restore-label-coulmn2">
        <mat-radio-group
          class=""
          aria-label="Select an option"
          [(ngModel)]="sectionType"
        >
          <mat-radio-button [value]="1">minor changes (1.1)</mat-radio-button>
          <br />
          <mat-radio-button [value]="2">major changes (2.0)</mat-radio-button>
        </mat-radio-group>
      </td>
    </tr>
    <tr class="wk-restore-label-row2">
      <td class="wk-restore-label-coulmn3">
        <span>
          <label for="comments">Comments:</label>
        </span>
      </td>
      <td class="wk-restore-label-coulmn4">
        <span>
          <textarea
            class="wk-restore-label-textarea"
            [(ngModel)]="data.comment"
          >
          </textarea>
        </span>
      </td>
    </tr>
  </table>
  <mat-toolbar class="wk-restore-button">
    <mat-toolbar-row
      class="wk-restore-button-row wk-restore-button-align-items"
    >
      <span>
        <button
          type="button"
          class="wk-button wk-button-ghost wk-save-btn"
          (click)="saveVersion()"
        >
          {{'ADF_VERSION_LIST.OK_BUTTON' | translate}}
        </button>
      </span>
      <span>
        <button
          type="button"
          class="wk-button wk-button-ghost wk-close-btn"
          (click)="closeDialog()"
        >
          {{'ADF_VERSION_LIST.CANCEL_BUTTON' | translate }}
        </button>
      </span>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
